import React from "react";
import styled, { keyframes } from "styled-components";

const spin = keyframes`
  to { transform: rotate(360deg); }
`;

export interface SpinnerProps {
  size?: number;
  /** Stroke width in the 24-unit viewBox. */
  strokeWidth?: number;
  /** SVG dash pattern; the circle's circumference is ~56.5 units. */
  dashArray?: string;
  className?: string;
}

const Svg = styled.svg`
  animation: ${spin} 0.9s linear infinite;
`;

/**
 * Spinner — single-arc loader with rounded caps. Inherits color from
 * `currentColor` so callers control hue via `color:` on a wrapper.
 */
export const Spinner: React.FC<SpinnerProps> = ({
  size = 24,
  strokeWidth = 2.5,
  dashArray = "14 60",
  className,
}) => (
  <Svg
    className={className}
    width={size}
    height={size}
    viewBox="0 0 24 24"
    fill="none"
    aria-hidden="true"
  >
    <circle
      cx="12"
      cy="12"
      r="9"
      stroke="currentColor"
      strokeWidth={strokeWidth}
      strokeLinecap="round"
      strokeDasharray={dashArray}
    />
  </Svg>
);

export default Spinner;
